import type { UIMessage } from '@ai-sdk/react';
import type { UIDataTypes, UITools } from 'ai';
import AIChatActions from '../AIChatActions';
import Loading from '../elements/Loading';
import { Message, MessageContent } from '../elements/Message';
import AssistantToolResults from './AssistantToolResults';
import { useAIChatMessagesContext } from './context';
import MessagePart from './MessagePart';
import ToolLoadingList from './ToolLoadingList';
import type { ChatMessagePart } from './utils';

type Props = {
  isLastMessage: boolean;
  message: UIMessage;
};

const Item = ({ isLastMessage, message }: Props) => {
  const { hideAvatar, hideTools, lastMessageId, messageContentClassName, onRegenerate, source, status } = useAIChatMessagesContext();
  const isStreaming = status === 'streaming';
  const isAssistant = message.role === 'assistant';
  const isLastMessageId = message.id === lastMessageId;
  const parts = message.parts as ChatMessagePart[];
  const shouldShowLoading = status !== 'ready' && isLastMessageId;

  return (
    <div className='relative flex-row'>
      {shouldShowLoading && <Loading message={message} isAssistant={isAssistant} />}
      <Message from={message.role} hideAvatar={hideAvatar}>
        <MessageContent className={messageContentClassName}>
          {parts.map((part, index) => (
            <MessagePart
              key={`${message.id}-${index}-${part.type}`}
              index={index}
              isLastMessage={isLastMessage && isLastMessageId}
              isStreaming={isStreaming}
              message={message}
              part={part}
            />
          ))}

          {isAssistant && isStreaming && isLastMessage && !hideTools && <ToolLoadingList parts={parts} />}
          {isAssistant && !isStreaming && !hideTools && <AssistantToolResults message={message} />}
          {isAssistant && status !== 'streaming' && isLastMessage && (
            <AIChatActions onRegenerate={onRegenerate} message={message as UIMessage<UIDataTypes, UITools>} source={source} />
          )}
        </MessageContent>
      </Message>
    </div>
  );
};

export default Item;
